import { render, staticRenderFns } from "./GioDistributionChart.vue?vue&type=template&id=1482e69e&scoped=true&"
import script from "./GioDistributionChart.vue?vue&type=script&lang=js&"
export * from "./GioDistributionChart.vue?vue&type=script&lang=js&"
import style0 from "./GioDistributionChart.vue?vue&type=style&index=0&id=1482e69e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482e69e",
  null
  
)

export default component.exports